<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-map-marker-alt"></i> Endereço
        </div>
        <div class="card-block form form-horizontal">
            <div class="form-group row">
                <div class="col-md-3">
                    <label>CEP</label>
                    <div class="input-group">
                        <input
                            type="text"
                            maxlength="20"
                            class="form-control"
                            v-model="model.cep"
                        />
                        <div class="input-group-btn" v-if="pais && pais.codigo == 'BR'">
                            <button type="button" class="btn btn-primary" @click="searchCep()">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <div
                    class="col-md-6 col-xs-12"
                    :class="{ 'dropdown-has-error': $v.model.id_estado.$error }"
                >
                    <label>Estado*</label>
                    <dw-select
                        :options="states"
                        v-model="model.id_estado"
                        opt-text="nome"
                        placeholder="Selecione um estado"
                        @change="listCities()"
                    >
                        <option value="0" selected>Selecione um estado</option>
                    </dw-select>
                </div>

                <div
                    class="col-md-6 col-xs-12"
                    :class="{ 'dropdown-has-error': $v.model.id_cidade.$error }"
                >
                    <label>Cidade*</label>
                    <dw-select
                        :options="cities"
                        v-model="model.id_cidade"
                        opt-text="nome"
                        placeholder="Selecione uma cidade"
                    >
                        <option value="0" selected>Selecione uma cidade</option>
                    </dw-select>
                </div>
            </div>

            <div class="form-group row">
                <div
                    class="col-md-6 col-xs-12"
                    :class="{ 'has-danger': $v.model.logradouro.$error }"
                >
                    <label>Logradouro*</label>
                    <input
                        type="text"
                        maxlength="250"
                        class="form-control"
                        v-model="model.logradouro"
                    />
                </div>
                <div class="col-md-2 col-xs-12" :class="{ 'has-danger': $v.model.numero.$error }">
                    <label>Número*</label>
                    <input type="text" maxlength="20" class="form-control" v-model="model.numero" />
                </div>
                <div class="col-md-4 col-xs-12">
                    <label>Complemento</label>
                    <input
                        type="text"
                        maxlength="45"
                        class="form-control"
                        v-model="model.complemento"
                    />
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-6 col-xs-12" :class="{ 'has-danger': $v.model.bairro.$error }">
                    <label>Bairro*</label>
                    <input type="text" maxlength="150" class="form-control" v-model="model.bairro" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <button type="button" class="btn btn-primary" @click="findOnMap">
                        Encontrar no Mapa
                    </button>

                    <hr>

                    <div class="card">
                        <gmap-map
                                :center="googleMap.center"
                                :zoom="17"
                                style="width: 100%; height: 300px"
                        >
                            <gmap-marker
                                    :key="index"
                                    v-for="(m, index) in googleMap.markers"
                                    :position="m.position"
                                    :clickable="true"
                                    :draggable="true"
                                    @click="googleMap.center=m.position"
                                    @position_changed="setMarkerNewPosition"
                            ></gmap-marker>
                        </gmap-map>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Facade from "../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isUndefinedOrNullOrEmpty,
    isNotUndefinedOrNullOrEmptyOrZero,
    formatPhone,
    formatCpf,
    formatCep,
    clearCpfCnpj
} from "@/services/string";
import {searchAddress} from '../services/google_geocoding'

export default {
    name: "DWFormAddress",
    props: ["model", "id_pais", "pais"],
    data() {
        return {
            states: [],
            cities: [],
            googleMap: {
                center: {lat: 10.0, lng: 10.0},
                markers: [],
            },
            loadedMap: false
        };
    },
    watch: {
        'model.latitude': function () {
            const vm = this;
            if (vm.model.id > 0 && vm.model.latitude && vm.model.longitude && !vm.loadedMap) {
                let latLng = {
                    lat: parseFloat(vm.model.latitude || 10),
                    lng: parseFloat(vm.model.longitude || 10)
                }

                vm.googleMap.center = latLng
                vm.googleMap.markers.push({
                    position: latLng
                })

                vm.loadedMap = true;
            }
        },
        'id_pais': function () {
            const vm = this;
            vm.states = [];
            let params = { params: { id_pais: vm.id_pais } };
            facade.listState(params).then(response => {
                vm.states = response.data.data;
                if (vm.model.cidade != null && vm.model.cidade.id_estado != null) {
                    vm.model.id_estado = vm.model.cidade.id_estado;
                    // vm.model.cep = vm.model.cep ? formatCep(vm.model.cep) : "";
                    this.listCities();
                }
            });
        }
    },
    validations() {
        return {
            model: {
                logradouro: {
                    required
                },
                numero: {
                    required
                },
                bairro: {
                    required
                },
                id_estado: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                },
                id_cidade: {
                    required,
                    isNotUndefinedOrNullOrEmptyOrZero
                }
            }
        };
    },
    methods: {
        setMarkerNewPosition(markers) {
            this.model.latitude = markers.lat()
            this.model.longitude = markers.lng()
        },
        findOnMap() {
            const vm = this

            this.$loading.show(true);

            let estado = _.find(vm.states, (item) => {
                return item.id == vm.model.id_estado
            })

            let cidade = _.find(vm.cities, (item) => {
                return item.id == vm.model.id_cidade
            })

            const result = searchAddress({
                logradouro: this.model.logradouro,
                numero: this.model.numero,
                bairro: this.model.bairro,
                cidade: cidade.nome,
                estado: estado.nome,
                pais: (this.pais ? this.pais.codigo : '')
            }).then(data => {
                this.$loading.show(false);

                if (!data.geometry) {
                    this.$notify.error('Não foi possível localizar no mapa. Verifique o endereço.');
                } else {
                    vm.googleMap.markers = []

                    vm.googleMap.markers.push({
                        position: {
                            lat: data.geometry.location.lat,
                            lng: data.geometry.location.lng,
                        }
                    })

                    vm.googleMap.center = {
                        lat: data.geometry.location.lat,
                        lng: data.geometry.location.lng,
                    }

                    vm.model.latitude = data.geometry.location.lat;
                    vm.model.longitude = data.geometry.location.lng;

                }
            })
        },
        isInvalid() {
            this.$v.model.$touch();
            return this.$v.model.$invalid;
        },
        searchCep() {
            let vm = this;
            if (!isUndefinedOrNullOrEmpty(vm.id_pais) &&
                !isUndefinedOrNullOrEmpty(vm.model.cep) &&
                vm.model.cep.length === 9
            ) {
                this.$loading.show(true);

                let ret = facade.searchCep(vm.model.cep);
                ret.then(response => {
                    const address = response.data.data;

                    vm.model.logradouro = address.logradouro;
                    vm.model.bairro = address.bairro;

                    const state = _.find(this.states, { uf: address.uf });
                    vm.model.id_estado = state.id;

                    //BUSCA AS CIDADES
                    this.cities = [];
                    vm.model.id_cidade = 0;

                    let params = { params: { id_estado: vm.model.id_estado } };

                    let retcities = facade.listCity(params);
                    retcities
                        .then(response => {
                            this.cities = response.data.data;

                            const city = _.find(this.cities, {
                                codigo: address.ibge
                            });
                            vm.model.id_cidade = city.id;

                            this.$loading.show(false);
                        })
                        .catch(e => {
                            this.$notify.error(
                                "Erro!",
                                "Ocorreu um problema ao listar as cidades."
                            );
                            this.$loading.show(false);
                        });

                    this.$loading.show(false);
                }).catch(e => {
                  console.log(e);
                    this.$notify.error(
                        "Erro!",
                        "Ocorreu um problema ao buscar o cep."
                    );
                    this.$loading.show(false);
                });
            } else {
              this.$notify.error('Por favor selecione o país.');
            }
        },
        listCities() {
            let vm = this;
            vm.cities = [];
            // vm.model.id_cidade = 0;
            this.$loading.show(true);

            let params = { params: { id_estado: vm.model.id_estado } };

            let ret = facade.listCity(params);
            ret.then(response => {
                vm.cities = response.data.data;
                this.$loading.show(false);
            }).catch(e => {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar as cidades."
                );
                this.$loading.show(false);
            });
        }
    },
    beforeMount() {
        const vm = this;
        let params = { params: { id_pais: vm.id_pais } };
        facade.listState(params).then(response => {
            vm.states = response.data.data;
            if (vm.model.cidade != null && vm.model.cidade.id_estado != null) {
                vm.model.id_estado = vm.model.cidade.id_estado;
                // vm.model.cep = vm.model.cep ? formatCep(vm.model.cep) : "";
                this.listCities();
            }
        });
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// DWFormAddress.vue?0b35700c